import { keyframes } from "@mui/system";
import { Slide } from "@mui/material";
import { forwardRef } from "react";

export const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const animationDuration = `3500ms`;
export const animationTiming = `cubic-bezier(0.37, 0, 0.63, 1)`;
export const animationKeyFramesGrow = keyframes`
  0% {
    background-color: rgba(25, 83, 183, 0.08);
    height: 0;
    min-height: 0;
    opacity: 0;
    transform: scaleY(0);
  }
  12.5% {
    height: 52px;
    min-height: 52px;
    transform: scaleY(1);
    background-color: rgba(25, 83, 183, 0.1);
  }
  40% {
    opacity: 1;
  }
  85% {
    background-color: rgba(25, 83, 183, 0.1);
    opacity: 1;
  }
  100% {
    background-color: inherit;
  }
`;

export const animationKeyFramesPulse = keyframes`
  0% {
    background-color: rgba(25, 83, 183, 0.1);
  }
  50% {
    background-color: rgba(25, 83, 183, 0.1);
  }
  85% {
    background-color: rgba(25, 83, 183, 0.1);
  }
  100% {
    background-color: inherit;
  }
`;

export const animationKeyFramesShrink = keyframes`
  0% {
    height: 52px;
    min-height: 52px;
    transform: scaleY(1);
    background-color: rgba(25, 83, 183, 0.1);
  }
  12.5% {
    background-color: rgba(25, 83, 183, 0.08);
    height: 0;
    min-height: 0;
    opacity: 0;
    transform: scaleY(0);
  }
  100% {
    background-color: rgba(25, 83, 183, 0.08);
    height: 0;
    min-height: 0;
    opacity: 0;
    transform: scaleY(0);
  }
`;
